export const COLORS = {
  BLUE_BRIGHT: '#1eb8e7',
  BLUE_LIGHT: '#007896',
  BLUE_LIGHTEST: '#E4EDFD',
  BLUE_SKY: '#55b6e2',
  BLUE_LIGHT_DARKISH: '#006077',
  BLUE_GREY: '#b5bfc7',
  BLUE_GREY_LIGHTEST: '#fafcfc',
  BLUE_DARK_SLATE: '#163150',
  BLUE_DARK: '#1c314e',
  BLUE_MYC: '#007A99',

  LEMON_GRASS: '#99968c',
  LIGHT_GREEN: '#B3DD87',
  SUCCESS_GREEN: '#5dba5a',
  SUCCESS_GREEN_LIGHT: '#b3dd87',
  WARNING_ORANGE: '#fa873f',
  ERROR_RED: '#ff5050',
  PASTEL_RED: '#ef4747',
  ERROR_RED_LIGHT: '#dd544e',

  WHITE: '#fff',
  GREY_LIGHTEST: '#f7f7f7',
  GREY_LIGHTER: '#e5ecf3',
  GREY_LIGHT: '#d8d8d8',
  GREY: '#b7bfc6',
  GREY_DARK: '#7b8695',
  GREY_DARKER: '#7b8695',
  GREY_DARKEST: '#282d32',
  BLACK: '#000',

  GREY_GEYSER: '#d6dce5',
  GREY_ATHENS: '#e8eaed',
  GREYISH_BROWN: '#424242',

  LIGHT_PURPLE: '#A682FF',
  PURPLE: '#a086f7',
  ORANGE: '#fa863f',
  GREEN: '#28a745',
  RED: '#FF0000',

  BG_GRAY: '#f6f8fa'
};

export const BREAK_POINTS = {
  SCREEN_XS: '512px',
  SCREEN_SM: '850px',
  SCREEN_MD: '1080px',
  SCREEN_LG: '1280px',
  SCREEN_XL: '1440px',
  SCREEN_XXL: '1600px'
};

export const FONT_SIZE = {
  XS: '12px',
  SM: '14px',
  BASE: '16px',
  MD: '18px',
  LG: '20px',
  XL: '24px',
  XXL: '36px'
};

export const LINE_HEIGHT = {
  XXS: '8px',
  XS: '12px',
  SM: '14px',
  BASE: '16px',
  MD: '18px',
  LG: '20px',
  XL: '24px',
  XXL: '36px'
};

export const SPACING = {
  NONE: '0px',
  XS: '5px',
  SM: '10px',
  BASE: '20px',
  MD: '30px',
  LG: '40px',
  XL: '60px',
  XXL: '100px'
};

export const MAX_CONTENT_WIDTH = '1700px';
export const MIN_CONTENT_PADDING = '15px';
